module.exports = __webpack_public_path__ + "img/s10-min.866f7227.png";